.table {
    border: none;
    border-collapse: collapse;
    width: 100%;

    & tbody {
        border-bottom: 1px solid var(--article-border);

        &:last-child {
            border-bottom: none;
        }

        & th,
        & td {
            border: none;
            padding: 0.5rem 0.75rem;
        }

        & th {
            font-weight: 700;
            vertical-align: middle;
            white-space: nowrap;
        }
    }

    & tbody tr:nth-child(even) {
        background-color: transparent;
    }
}

.headerVat {
    color: #22a3ab;
}

.headerAccounts {
    color: #89af00;
}

.headerPayroll {
    color: #bc5108;
}

.cellWrapper {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 1rem;
}

.debetCredit {
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: var(--mantine-color-gneis-5);
    text-transform: uppercase;
    white-space: nowrap;
}

.taxRow {
    display: flex;
    align-items: baseline;
    gap: 0.5rem 0.75rem;
    flex-wrap: wrap;
    padding-top: 0.25rem;
    border-top: 1px solid var(--article-border-subtle);
}

.taxLink {
    color: inherit;
    cursor: pointer;
    text-underline-offset: 0.15em;
    text-decoration-thickness: 1px;
    font-size: 0.8125rem;
}

.taxTruthy {
    text-decoration: underline dotted;
}

.taxFalsy {
    text-decoration: line-through;
    color: var(--mantine-color-gneis-4);
}
